//
// Module for the Benefit Estimate Detail view
//
rs.module("participant/benefit/benefitestimates/detail",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls) {
            var estimateInfo = $.js(jsSelectors.estimateInfo);

            var onMDCheckBox = estimateInfo.js(jsSelectors.onMDCheckBox);
            var onMDSpinner = estimateInfo.js(jsSelectors.onMDSpinner);

            // On checkbox change, reload the grid data via ajax
            onMDCheckBox.change(function () {

                onMDSpinner.show();

                // Make AJAX call to update the estimate
                $.post(
                    ajaxUrls.updateViewEstimateOnline,
                    { benefitEstimateKey: onMDCheckBox.data("benefitestimatekey"), viewEstimateOnline: this.checked }
                ).always(function () {
                    // Hide update spinner
                    onMDSpinner.hide();
                });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);